<template>
    <div class="qr-card">
        <el-row type="flex" align="middle" justify="center">
            <div id="qrCard">
                <div class="inner-qr-card">
                    <div class="serrated">
                        <el-row type="flex" align="middle" justify="space-between">
                            <div class="text-md-left">
                                <img src="@/assets/all-customer/fg-logo.png" class="w-50">
                            </div>
                            <div>
                                <img src="@/assets/all-customer/twodot.png" class="w-50">
                            </div>
                        </el-row>
                        <el-row type="flex" align="center" justify="center">
                            <img class="qr-code-box" :src="'data:image/png;base64,' + historyDetail.qrCodeImageBase64">
                        </el-row>
                        <el-row type="flex" align="center" justify="center" class="my-8">
                            <span class="font-12">กรุณาชำระเงินภายในวันที่ {{formatDatetoth(historyDetail.qrCodeExpiredAt)}}</span>
                        </el-row>
                    </div>
                    <el-row class="m-16">
                        <el-col :span="24" class="text-md-left">
                            <div class="">
                                <p class="head-font text-black">รายละเอียดค่าบริการ</p>
                            </div>
                            <el-row type="flex" align="middle" justify="space-between">
                                <div>
                                    <span>ราคา</span><br>
                                    <div v-if="historyDetail.discountAmount !== 0">
                                        <span class="text-red">ส่วนลด</span><br>
                                    </div>
                                    <div v-if="historyDetail.discountAmount === 0">
                                        <span>ส่วนลด</span><br>
                                    </div>
                                    <span class="text-black">ราคาหลังหักส่วนลด</span>
                                </div>
                                <div class="text-md-right">
                                    <span>{{numberWithCommas(historyDetail.salesPriceAmount)}} บาท</span><br>
                                    <div v-if="historyDetail.discountAmount !== 0">
                                        <span class="text-red">-{{numberWithCommas(historyDetail.discountAmount)}} บาท</span><br>
                                    </div>
                                    <div v-if="historyDetail.discountAmount === 0">
                                        <span>{{historyDetail.discountAmount.toFixed(2)}} บาท</span><br>
                                    </div>
                                    <span class="text-black">{{numberWithCommas(historyDetail.priceAfterDiscount)}} บาท</span>
                                </div>
                            </el-row>
                            <el-divider class="divider-dash"></el-divider>
                            <el-row type="flex" align="middle" justify="space-between">
                                <div>
                                    <span>ภาษีมูลค่าเพิ่ม 7%</span><br>
                                    <span v-if="historyDetail.whtAmount === 0" class="text-green">ยอดรวมที่ต้องชำระ</span>
                                    <span v-else class="text-black">ยอดรวม</span>
                                </div>
                                <div class="text-md-right">
                                    <span>{{numberWithCommas(historyDetail.vatAmount)}} บาท</span><br>
                                    <span v-if="historyDetail.whtAmount === 0" class="text-green">{{numberWithCommas(historyDetail.netPriceAmount)}} บาท</span>
                                    <span v-else class="text-black">{{numberWithCommas(historyDetail.totalPrice)}} บาท</span>
                                </div>
                            </el-row>
                            <el-divider v-if="historyDetail.whtAmount" class="divider-dash"></el-divider>
                            <el-row v-if="historyDetail.whtAmount" type="flex" align="middle" justify="space-between">
                                <div>
                                    <span>หัก ณ ที่จ่าย 3%</span><br>
                                    <span class="text-green">ยอดรวมที่ต้องชำระ</span>
                                </div>
                                <div class="text-md-right">
                                    <span>{{numberWithCommas(historyDetail.whtAmount)}} บาท</span><br>
                                    <span class="text-green">{{numberWithCommas(historyDetail.netPriceAmount)}} บาท</span>
                                </div>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-row>
        <el-row type="flex" align="center" justify="center" class="mt-16">
            <el-button type="primary" @click="qrDownload">บันทึก QR Code</el-button>
        </el-row>
    </div>
</template>

<script>
import numberWithCommas from '@/mixins/formatDigitMixin'
import saveAs from 'file-saver'
import * as htmlToImage from 'html-to-image'
export default {
    name: 'qrPayment',
    mixins: [numberWithCommas],
    props: {
        historyDetail: {
            type: Object,
            default: null
        },
        detail: {
            type: Object,
            default: null
        },
        userCode: {
            type: String,
            default: null
        }
    },
    methods: {
        async qrDownload () {
            try {
                let userCode = this.detail ? this.detail.userCode : this.userCode
                let dom = document.getElementById('qrCard')
                htmlToImage.toBlob(dom)
                    .then(function (blob) {
                        saveAs(blob, `qr-payment-${userCode}.png`)
                    })
            } catch (error) {
                console.log(error)
            }
        },
        formatDatetoth (dateOldFormat) {
            const date = new Date(dateOldFormat)
            const result = date.toLocaleDateString('th-TH', {
                year: '2-digit',
                month: 'short',
                day: 'numeric'
            })
            return result
        }
    }
}
</script>

<style lang="css">
</style>
<style lang="scss" scoped>
::v-deep .divider-dash {
    border: 1px dashed #D1D5E0;
    background-color: transparent !important;
}
.qr-card {
    max-width: 352px;
    height: auto;
    border: 1px solid #E4E6EE;
    border-radius: 4px;
    padding: 16px;
    .m-16 {
        margin: 16px;
    }
    .mt-16 {
        margin-top: 16px;
    }
    .inner-qr-card {
        width: 320px;
        min-height: 600px;
        background: #F8F9F8;
        white-space: nowrap;
        .w-50 {
            width: 50%;
        }
        .my-8 {
            margin-top: 8px;
            margin-bottom: 8px;
        }
        .head-font{
            font-size: 16px;
        }
        .font-12 {
            font-size: 12px;
        }
        $fg-green: #328647;
        .text-green {
            color: $fg-green !important;
        }
        .serrated {
            color: #fff;
            width: 100%;
            height: 50%;
            padding: 10px 10px;
            border: 10px solid transparent;
            border-top: none;
            border-width: 10px 0;
            background-color: $fg-green;
            background-color: hsla(0, 0%, 0%, 0);
            background-image:
                linear-gradient($fg-green),
                linear-gradient(to bottom right, transparent 50.5%, $fg-green 50.5%),
                linear-gradient(to bottom left, transparent 50.5%, $fg-green 50.5%),
                linear-gradient(to top right, transparent 50.5%, $fg-green 50.5%),
                linear-gradient(to top left, transparent 50.5%, $fg-green 50.5%);
            background-repeat: repeat, repeat-x, repeat-x, repeat-x, repeat-x;
            background-position: 0px 0px, 0px 10px, 10px 10px, 10px 100%, 10px 100%;
            background-size: auto auto, 20px 20px, 20px 20px, 20px 20px, 20px 20px;
            background-clip: padding-box, border-box, border-box, border-box, border-box;
            background-origin: padding-box, border-box, border-box, border-box, border-box;
        }
        .qr-code-box {
            width: 176px;
            height: 176px;
            background: #fff;
        }
    }
}
</style>
